import { render } from "./B.vue?vue&type=template&id=16c140cc"
import script from "./B.vue?vue&type=script&lang=js"
export * from "./B.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__